<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список пользователей"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-account"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Пользователи
        </div>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Поиск"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-checkbox
        v-model="form.deleted"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Показывать удаленных"
        hide-details
        single-line
        @change="load"
      />
      <v-divider class="mt-3" />

      <v-data-table
        :headers="table.headers"
        :items="table.items"
        :search.sync="search"
        :sort-by="['surname', 'name', 'role']"
        :sort-desc="[false]"
        multi-sort
        :footerProps="datatable_footer"
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="show_save_dialog(item)"
          >
            mdi-eye
          </v-icon>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn
          color="primary"
          min-width="100"
          @click="show_create_dialog"
        >
          Создать
        </v-btn>
      </v-card-actions>
    </base-material-card>
    <v-dialog
      v-model="dialog.user.show"
      width="700"
      persistent
    >
      <users-form
        :show="dialog.user.show"
        :user="dialog.user.data"
        :title="dialog.user.title"
        @create="create_user"
        @save="save_user"
        @close="dialog.user.show=false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
  import UsersForm from './UsersForm.vue'
  export default {
    components: { UsersForm },
    data () {
      return {
        datatable_footer: {
          itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
        form: {
          deleted: false,
        },
        isMobile: false,
        table: {
          headers: [
            { text: 'Телефон', value: 'phone' },
            { text: 'Фамилия', value: 'surname' },
            { text: 'Имя', value: 'name' },
            { text: 'Отчество', value: 'patronymic' },
            { text: 'Роль', value: 'role_string' },
            { text: 'Действия', value: 'action' },
          ],
          items: [],
          current: null,
        },
        dialog: {
          user: {
            title: '',
            show: false,
            create: true,
            data: null,
          },
        },
        search: '',
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      create_user: function (data) {
        this.axios.post('/api/user/create/', data)
          .then(response => {
            if (!response.data.error) {
              this.load()
              this.$store.commit('snackbar', 'Пользователь успешно создан')
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
        this.dialog.user.show = false
      },
      save_user: function (data) {
        this.axios.post('/api/user/save/', data)
          .then(response => {
            if (!response.data.error) {
              this.load()
              this.$store.commit('snackbar', 'Пользователь успешно обновлен')
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
        this.dialog.user.show = false
      },
      show_create_dialog: function () {
        this.dialog.user.title = 'Создание пользователя'
        this.dialog.user.data = null
        this.dialog.user.show = true
      },
      show_save_dialog: function (data) {
        this.dialog.user.title = 'Обновление пользователя'
        this.dialog.user.data = data
        this.dialog.user.show = true
      },
      load: function () {
        this.axios.post('/api/user/get/', this.form)
          .then(response => {
            if (!response.data.error) {
              for (let x in response.data.data) {
                response.data.data[x].role_string = this.$store.state.dict.role[response.data.data[x].role].name
                if (response.data.data[x].deleted) response.data.data[x].role_string += ' (удален)'
              }
              this.table.items = response.data.data
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
